import React, { useEffect, useState } from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_helpers";
import Tooltip from '@material-ui/core/Tooltip';

export const ThemeSwitch = () => {
    const [dark, setDark] = useState(false);
    const handleThemeSwitch = (v) => {
        if (v) {
            if (!document.body.classList.contains('dark')) {
                document.body.classList.add('dark');
                localStorage.setItem('mn-dark', 'dark');
                hideDarkTip();
            } else {
                document.body.classList.remove('dark');
                localStorage.setItem('mn-dark', 'light');
            }
        } else {
            document.body.classList.remove('dark');
            localStorage.setItem('mn-dark', 'light');
        }
        setDark(v);
    };
    const [darkTip, setDarkTip] = useState(true);
    const hideDarkTip = () => {
        localStorage.setItem('mn-dark-tip', 'hidden');
        setDarkTip(false);
    };
    const systemDefaultDark = (localStorage.getItem('mn-dark') === null && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);
    useEffect(() => {
        var _t = localStorage.getItem('mn-dark');
        var _dt = localStorage.getItem('mn-dark-tip');
        if (_t === 'dark' || systemDefaultDark) setDark(true);
        if (_dt === 'hidden') setDarkTip(false);
    }, [setDark, setDarkTip, systemDefaultDark]);
    return (<>
        <div style={{ paddingLeft: '12px' }}>
            <Tooltip title={dark ? 'Lights on' : 'Lights off'}>
                <span className={`svg-icon svg-icon- cursor-pointer svg-icon-${(dark ? 'white' : 'primary')}`} onClick={() => handleThemeSwitch(!dark)}>
                    <SVG src={toAbsoluteUrl(`/_media/svg/icons/Weather/Sun.svg`)} />
                </span>
            </Tooltip>
            {/* {!dark && darkTip && <div className="lights-off-tip">
                <span>If it's too bright for you, turn the lights off. <span className="close" title="Okay, got it" onClick={() => hideDarkTip()}></span></span>
            </div>} */}
        </div>
    </>);
}